import PropTypes from 'prop-types';
import React from 'react';

import * as D from '../../../deps';
import BackstagePodcastProgramPageBase from '../../pages/BackstagePodcastProgramPageBase';

import BackstagePodcastProgramMainContent from './BackstagePodcastProgramMainContent';

const BackstagePodcastProgram = props => {
  const programId = D.Utils.Route.getParamFromProps(props, 'podcastId');
  return (
    <BackstagePodcastProgramPageBase
      programId={programId}
      mainContent={<BackstagePodcastProgramMainContent programId={programId} />}
    />
  );
};

BackstagePodcastProgram.propTypes = {
  params: PropTypes.shape({
    podcastId: PropTypes.string.isRequired,
  }),
};

export default BackstagePodcastProgram;
